const oidc_configs = {
    sessions_card_title: 'Сессии Logto',
    sessions_card_description: 'Настройте политику сессий, хранящуюся на сервере авторизации Logto. Она фиксирует глобальное состояние аутентификации пользователя, чтобы включить SSO и позволить тихую повторную аутентификацию между приложениями.',
    session_max_ttl_in_days: 'Максимальное время жизни сессии (TTL) в днях',
    session_max_ttl_in_days_tip: 'Абсолютный предел времени жизни с момента создания сессии. Независимо от активности сессия завершается по истечении этого фиксированного срока.',
    cloud_private_key_rotation_notice: 'В Logto Cloud ротация закрытого ключа вступает в силу после 4-часового льготного периода.',
};
export default Object.freeze(oidc_configs);
